/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useCallback, useRef, useState } from 'react';
import clsx from 'clsx';
import customStyles from "../../../assets/styles/customStyles";
import MainHeader from "../../Shared/components/Header";
import { Row, Col } from "antd";
import Menus from "./Menus";
import PurchaseIcon from "../../../assets/images/icon_menus/PurchaseIcon.json";
import { useSelector, useDispatch } from "react-redux";
import { Trend, MonthlySales, TopTen, Total, OverDue, NoData } from "../../Shared/components/Dashboard";
import { Swiper, SwiperSlide } from "swiper/react";
import { checkModuleViewPermission, storageGetItem } from '../../../helpers/utilities';
import SwiperCore, {
    Navigation,
    Pagination,
    Autoplay,
    Virtual
} from "swiper/core";
import action from "./redux/actions";

SwiperCore.use([Navigation, Pagination, Autoplay, Virtual]);

const Purchase = (props) => {
    const { roleManagement } = useSelector(state => state.authReducer);
    const { purchaseDashboardDetails } = useSelector(state => state.purchaseDashboardReducer);
    const [height, setHeight] = useState(300);
    const [menuHeight, setMenuHeight] = useState(0);
    const leftRef = useRef('');
    const { history } = props;
    const dispatch = useDispatch();


    const calculateHeight = () => {
        if (document.querySelectorAll(`.menuCheck`).length > 0) {
            if (leftRef && leftRef?.current)
                setMenuHeight(leftRef.current.offsetHeight + 25);
            if (document.querySelectorAll(`.${classes.primaryMenu}`) && document.querySelectorAll(`.${classes.primaryMenu}`).length > 0 && leftRef.current) {
                let height = document.querySelectorAll(`.${classes.primaryMenu}`)[0].offsetHeight;
                let offsetHeight = leftRef?.current?.offsetHeight + height + 23;
                setHeight(offsetHeight);
            }
        }
    }

    useEffect(() => {
        if (roleManagement !== '') {
            if (checkModuleViewPermission('Purchase', history)) {
                loadTasks();
                setTimeout(() => {
                    calculateHeight();
                }, 100);
            }
        }
    }, [roleManagement]);


    const loadTasks = useCallback(() => {
        dispatch({ type: action.PURCHASE_DASHBOARD_START, url: 'purchasedashboard' });
    });


    const classes = customStyles();
    return (
        <React.Fragment>
            <MainHeader  {...props} img={PurchaseIcon} title={'Purchase'} links={[{ 'label': 'Home', 'link': '/' }, { 'label': 'Purchase', 'link': '' }]} close={false} />
            <div className={clsx(classes.listTableMargin, classes.containerBorder, classes.cardEHeight)}>
                <Row gutter={25} className={classes.dashboardRow}>
                    <Col xs={24} sm={24} md={12} lg={12} xl={16} xxl={16}>
                        <Row gutter={25} ref={leftRef}>
                            <Col xs={24} sm={24} md={24} lg={24} xl={12} xxl={12}>
                                <div className={clsx(classes.boxBorder)}>
                                    <div className={clsx(classes.boxBorderInner)}>
                                        {
                                            purchaseDashboardDetails !== undefined && purchaseDashboardDetails !== '' ?
                                                <>
                                                    {
                                                        purchaseDashboardDetails?.sales_month?.invoices.reduce((a, v) => a = a + v, 0) === 0 ? <NoData /> : <Trend title="Purchase Trend"
                                                            toolTip="Values displayed includes only original transaction data and does not include any reversals or debit note"
                                                            months={purchaseDashboardDetails?.sales_month?.months}
                                                            invoiceCounts={purchaseDashboardDetails?.sales_month?.invoices}
                                                            invoiceAmounts={purchaseDashboardDetails?.sales_month?.amounts}
                                                        />
                                                    }
                                                </>
                                                : <div className={classes.loadMoreCircle}></div>
                                        }
                                    </div>
                                </div>
                            </Col>
                            <Col xs={24} sm={24} md={24} lg={24} xl={12} xxl={12} className={classes.secondBox}>
                                <div className={clsx(classes.boxBorder)}>
                                    <div className={clsx(classes.boxBorderInner)}>
                                        {
                                            purchaseDashboardDetails !== undefined && purchaseDashboardDetails !== '' ?
                                                <>
                                                    {
                                                        purchaseDashboardDetails?.current_month_total === 0 && purchaseDashboardDetails?.last_month_total === 0 ? <NoData /> :
                                                            <MonthlySales title="Monthly Purchase Comparison"
                                                                sTitle="Purchase"
                                                                toolTip="Values displayed includes only original transaction data and does not include any reversals or debit note"
                                                                monthPercent={purchaseDashboardDetails?.month_percent}
                                                                currentMonthTotal={purchaseDashboardDetails?.current_month_total}
                                                                lastMonthTotal={purchaseDashboardDetails?.last_month_total}
                                                                percent_type={purchaseDashboardDetails?.percent_type}
                                                            />
                                                    }
                                                </>
                                                : <div className={classes.loadMoreCircle}></div>
                                        }
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        {
                            roleManagement !== '' && <Menus menuHeight={menuHeight} />
                        }
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={8} xxl={8} className={classes.thirdBox}>
                        <div className={clsx(classes.boxBorderH)} style={{ height: (height) + 'px' }}>
                            {
                                purchaseDashboardDetails !== undefined && purchaseDashboardDetails !== '' ? <>
                                    {
                                        purchaseDashboardDetails?.total_purchase_15 === 0 &&
                                            purchaseDashboardDetails?.total_purchase_30 === 0 &&
                                            purchaseDashboardDetails?.total_purchase_90 === 0 &&
                                            purchaseDashboardDetails?.top_suppliers_amount_60?.length === 0 &&
                                            purchaseDashboardDetails?.top_suppliers_amount_120?.length === 0 &&
                                            purchaseDashboardDetails?.top_suppliers_amount_300?.length === 0 &&
                                            purchaseDashboardDetails?.top_suppliers_invoice_60?.length === 0 &&
                                            purchaseDashboardDetails?.top_suppliers_invoice_120?.length === 0 &&
                                            purchaseDashboardDetails?.top_suppliers_invoice_300?.length === 0 &&
                                            purchaseDashboardDetails?.over_due_0_15?.length === 0 &&
                                            purchaseDashboardDetails?.over_due_15_30?.length === 0 &&
                                            purchaseDashboardDetails?.over_due_30_45?.length === 0 &&
                                            purchaseDashboardDetails?.over_due_more_45?.length === 0
                                            ? <NoData /> : <Swiper
                                                id="swiper"
                                                virtual
                                                autoplay={{
                                                    delay: 5000,
                                                    pauseOnMouseEnter: true
                                                }}
                                                allowTouchMove={false}
                                                loop
                                                pagination={{ clickable: true }}>
                                                <SwiperSlide key={`slide-1`} style={{ listStyle: "none" }}>
                                                    {
                                                        purchaseDashboardDetails?.total_purchase_15 === 0 &&
                                                            purchaseDashboardDetails?.total_purchase_30 === 0 &&
                                                            purchaseDashboardDetails?.total_purchase_90 === 0 ? <NoData /> :
                                                            <Total title="Total Purchase" sTitle={"Purchase Total"}
                                                                toolTip="Values displayed includes only original transaction data and does not include any reversals or debit note"
                                                                dataVisible={parseFloat(purchaseDashboardDetails?.total_purchase_15).toFixed(2)}
                                                                total_sales_15={parseFloat(purchaseDashboardDetails?.total_purchase_15).toFixed(2)}
                                                                total_sales_30={parseFloat(purchaseDashboardDetails?.total_purchase_30).toFixed(2)}
                                                                total_sales_90={parseFloat(purchaseDashboardDetails?.total_purchase_90).toFixed(2)} />
                                                    }

                                                </SwiperSlide>
                                                {
                                                    (storageGetItem('businessType') === 'MANUFACTURER' ||
                                                        storageGetItem('businessType') === 'AGENT/DEALER' ||
                                                        storageGetItem('businessType') === 'DISTRIBUTOR' ||
                                                        storageGetItem('businessType') === 'WHOLESALE' ||
                                                        storageGetItem('businessType') === 'SHOP/RETAILER' ||
                                                        storageGetItem('businessType') === 'OTHER') &&
                                                    storageGetItem('isPaying') && <SwiperSlide key={`slide-1`} style={{ listStyle: "none" }}>
                                                        {
                                                            purchaseDashboardDetails?.over_due_0_15?.length === 0 &&
                                                                purchaseDashboardDetails?.over_due_15_30?.length === 0 &&
                                                                purchaseDashboardDetails?.over_due_30_45?.length === 0 &&
                                                                purchaseDashboardDetails?.over_due_more_45?.length === 0 ? <NoData /> : <OverDue type={'purchase'} title={"Overdue Supplier Payments"}
                                                                    salesDashboardDetails={purchaseDashboardDetails} />
                                                        }
                                                    </SwiperSlide>
                                                }
                                                {
                                                    (storageGetItem('businessType') === 'MANUFACTURER' ||
                                                        storageGetItem('businessType') === 'SHOP/RETAILER') &&
                                                    storageGetItem('isPaying') && <SwiperSlide key={`slide-1`} style={{ listStyle: "none" }}>
                                                        {
                                                            purchaseDashboardDetails?.top_suppliers_amount_60?.length === 0 &&
                                                                purchaseDashboardDetails?.top_suppliers_amount_120?.length === 0 &&
                                                                purchaseDashboardDetails?.top_suppliers_amount_300?.length === 0 &&
                                                                purchaseDashboardDetails?.top_suppliers_invoice_60?.length === 0 &&
                                                                purchaseDashboardDetails?.top_suppliers_invoice_120?.length === 0 &&
                                                                purchaseDashboardDetails?.top_suppliers_invoice_300?.length === 0 ? <NoData /> : <TopTen title={"Top 10 Suppliers"} details={purchaseDashboardDetails} />
                                                        }
                                                    </SwiperSlide>
                                                }
                                            </Swiper>
                                    }
                                </> : <div className={classes.loadMoreCircle}></div>
                            }
                        </div>
                    </Col>
                </Row>
            </div>
        </React.Fragment>
    )
}

export default Purchase